import { SiteContextProvider, client } from "@provider";
import { ApolloProvider } from "@apollo/client";
import React from "react";

export const wrapPageElement: React.FC<{ element: React.ReactNode }> = ({
    element
}) => (
    <ApolloProvider client={client}>
        <SiteContextProvider>{element}</SiteContextProvider>
    </ApolloProvider>
);
